/** @format */


type KnowledgeBaseRatingProps = {
  rating?: number;
};

export const KnowledgeBaseRating = ({ rating = 0 }: KnowledgeBaseRatingProps) => {
  return (
    <div className="knowledge_base-widget--list-item-rating">
      {Array.from({ length: 5 }).map((_, index) => (
        <span key={index} className={index < Math.round(rating) ? 'rated' : ''}></span>
      ))}
    </div>
  );
};
